/**
 *
 *
 *
 *
 */
export function jsonParseSafe<T>(value: string | undefined | null): T | undefined {
  try {
    return typeof value === "string" ? JSON.parse(value) : undefined;
  } catch {
    return undefined;
  }
}

/**
 *
 *
 *
 *
 */
export const jsonParseOrUse = <T>(value: string): T | string => jsonParseSafe(value) ?? value;
